/* eslint-disable */
function q(elOrSelector) {
  if (!elOrSelector) return null;
  if (typeof elOrSelector === 'string') return document.querySelector(elOrSelector);
  if (elOrSelector.jquery) return elOrSelector[0];
  return elOrSelector;
}

function isVisible(el) {
  return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));
}

function validateVisibleRequired(container = document) {
  const required = Array.from(container.querySelectorAll('input[required], textarea[required], select[required]'));
  for (const el of required) {
    if (!isVisible(el)) continue;
    if (!el.value) {
      if (typeof el.reportValidity === 'function') el.reportValidity();
      return false;
    }
  }
  return true;
}

function show(el) {
  if (!el) return;
  el.style.display = '';
  el.style.position = '';
  el.style.opacity = '1';
}

function hide(el) {
  if (!el) return;
  el.style.display = 'none';
  el.style.position = 'relative';
  el.style.opacity = '0';
}

export function setProgressBar(currentStep, action, currentGfgStep, nextGfgStep, previousGfgStep, myform) {
  const form = q(myform) || document;
  const fieldsets = Array.from(form.querySelectorAll('fieldset'));
  const progressItems = Array.from(document.querySelectorAll('.progressbarregistrations li'));

  if (action === 'default') {
    fieldsets.forEach((fs, index) => {
      if (index === 0) {
        show(fs);
        progressItems[index]?.classList.add('active');
      } else {
        hide(fs);
        progressItems[index]?.classList.remove('active');
      }
    });
    updateProgressWidth(fieldsets, progressItems);
    return 1;
  }

  const current = q(currentGfgStep);
  const next = q(nextGfgStep);
  const previous = q(previousGfgStep);

  if (action === 'next') {
    if (!validateVisibleRequired(form)) return currentStep;
    hide(current);
    show(next);
    const nextIndex = fieldsets.indexOf(next);
    if (nextIndex >= 0) progressItems[nextIndex]?.classList.add('active');
  } else {
    hide(current);
    show(previous);
    const currentIndex = fieldsets.indexOf(current);
    if (currentIndex >= 0) progressItems[currentIndex]?.classList.remove('active');
  }

  updateProgressWidth(fieldsets, progressItems);
  return currentStep;
}

function updateProgressWidth(fieldsets, progressItems) {
  const active = progressItems.filter(li => li.classList.contains('active')).length;
  const steps = Math.max(1, fieldsets.length || progressItems.length || 1);
  const percent = Math.round((125 / steps) * active);
  document.querySelectorAll('.progress-bar-registrations').forEach(el => { el.style.width = `${percent}%`; });
}

export default { setProgressBar };
